jQuery('.card-hov').mouseenter(function () {
      jQuery(this).find(".noshowx").fadeOut(500);
        jQuery(this).find('.noshow').fadeIn(500);
     });

 jQuery('.card-hov').mouseleave(function () {
   jQuery(this).find(".noshow").fadeOut();
        jQuery(this).find('.noshowx').fadeIn();
      
     }
 ).mouseleave();


 $.fn.toggleAttr = function(attr, val) {
    var test = $(this).attr(attr);
    if ( test ) { 
      // if attrib exists with ANY value, still remove it
      $(this).removeAttr(attr);
    } else {
      $(this).attr(attr, val);
    }
    return this;
  };
$(".head_loc details").click(function(){
    $(this).attr("open", function(_, attr){
                    return attr ? null : "open";})
})